// Variant Image Filter - Handles spaces & special characters
(function(){
  
  // Normalize string: lowercase, remove special chars, spaces to hyphen
  function normalize(str){
    return str.toLowerCase()
      .trim()
      .replace(/&/g, '')           // remove &
      .replace(/[^a-z0-9\s-]/g, '') // remove special chars
      .replace(/\s+/g, '-')         // spaces to hyphen
      .replace(/-+/g, '-')          // multiple hyphens to single
      .replace(/^-|-$/g, '');       // trim hyphens
  }
  
  function filter(){
    var radios = document.querySelectorAll('variant-radios input[type="radio"]:checked, fieldset input[type="radio"]:checked');
    var selects = document.querySelectorAll('variant-selects select');
    
    var vals = [];
    radios.forEach(function(r){ vals.push(normalize(r.value)); });
    selects.forEach(function(s){ if(s.value) vals.push(normalize(s.value)); });
    
    if(vals.length === 0) return;
    
    var search = vals.join('-');
    console.log('Filtering:', search);
    
    var found = 0;
    var firstVisible = null;
    var firstThumb = null;
    
    // Filter main images
    document.querySelectorAll('.product__media-item').forEach(function(el){
      var img = el.querySelector('img');
      var alt = img ? normalize(img.alt) : '';
      var show = (alt === search);
      el.style.display = show ? '' : 'none';
      if(show) {
        found++;
        if(!firstVisible) firstVisible = el;
      }
    });
    
    // Filter thumbnails
    document.querySelectorAll('.thumbnail-list__item').forEach(function(el){
      var img = el.querySelector('img');
      var alt = img ? normalize(img.alt) : '';
      var show = (alt === search);
      el.style.display = show ? '' : 'none';
      if(show && !firstThumb) firstThumb = el;
    });
    
    // If nothing found, show all
    if(found === 0){
      document.querySelectorAll('.product__media-item, .thumbnail-list__item').forEach(function(el){
        el.style.display = '';
      });
      firstVisible = document.querySelector('.product__media-item');
      firstThumb = document.querySelector('.thumbnail-list__item');
    }
    
    // Activate first visible image
    if(firstVisible){
      document.querySelectorAll('.product__media-item').forEach(function(el){
        el.classList.remove('is-active');
      });
      firstVisible.classList.add('is-active');
      firstVisible.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'start' });
    }
    
    // Click first thumbnail
    if(firstThumb){
      var btn = firstThumb.querySelector('button');
      if(btn) setTimeout(function(){ btn.click(); }, 50);
    }
  }
  
  document.addEventListener('change', function(e){ 
    setTimeout(filter, 100); 
  });
  
  setTimeout(filter, 500);
})();